import React, { useContext } from 'react';

// Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { priceslists } from "library/constants";
import { WLSContext } from 'wls_context.js';
import { Typography } from '@material-ui/core';

export function SelectPricelistModal({ active, onDone, onClose, classes }) {

  return (
    <Dialog open={active} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Select a price list</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please, choose one from below.
        </DialogContentText>
        <Button onClick={() => onDone(null)}>
          None
        </Button>
        {priceslists.map(pl => (
          <Button key={pl} onClick={() => onDone(pl)}>
            {pl}
          </Button>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export function SelectPricelistModalLink(props) {
  const { active, onClose, linkBase } = props;

  const { ctx } = useContext(WLSContext);

  let prices = (ctx.user && (ctx.user.roles.includes("admin") ? priceslists : [ctx.user.pricelist])) || [];

  return (
    <Dialog open={active} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Select a price list</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please, choose one from below.
        </DialogContentText>
        <Button href={linkBase} target="_blank" component="a" >
          None
        </Button>
        {prices.map(pl => (
          <Button target="_blank" component="a" key={pl} href={`${linkBase}?pl=${pl}`}>
            {pl}
          </Button>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export function SelectPricelistModalTwoColumns(props) {
  const { active, onClose, linkBase } = props;

  const { ctx } = useContext(WLSContext);
  const [activeValues, setActiveValues] = React.useState({rt: null, wh: null});

  // Prices are a list of 4-character strings, where the first two characters are the retail price list
  // and the last two characters are the wholesale price list.
  const prices = (ctx.user && (ctx.user.roles.includes("admin") ? priceslists : [ctx.user.pricelist])) || [];
  let price_rt = [];
  let price_wh = [];


  for (let i = 0; i < prices.length; i += 1) {
    price_rt.push(prices[i].substring(0, 2));
    price_wh.push(prices[i].substring(2, 4));
  }

  const unique_rt = [...new Set(price_rt)];
  const unique_wh = [...new Set(price_wh)];

  const cleanUp = () => {
    setActiveValues({rt: null, wh: null});
    onClose();
  };

  return (
    <Dialog open={active} onClose={cleanUp} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Select price list</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please, choose one from below.
        </DialogContentText>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', flexDirection: 'column', marginRight: '20px' }}>
            <Typography variant="caption">PVP</Typography>
            <Button
             onClick={() => {setActiveValues((av)=> ({...av, rt: null}))}} 
             variant={ activeValues.rt === null ? "contained": "text"}
              >
              None
            </Button>
            {unique_rt.map(pl => (

              <Button
                onClick={() => {setActiveValues((av)=> ({...av, rt: pl}))}}
                key={pl}
                variant={ activeValues.rt === pl ? "contained": "text"}
                disabled={ (activeValues.wh !== null) && (prices.indexOf(pl + activeValues.wh) === -1) }
                >
                {pl}
              </Button>
            ))}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', marginRight: '20px' }}>
            <Typography variant="caption">Wholesale</Typography>
            <Button
              onClick={() => {setActiveValues((av)=> ({...av, wh: null}))}}
             variant={ activeValues.wh === null ? "contained": "text"}
              >
              None
            </Button>
            {unique_wh.map(pl => (
              <Button
                onClick={() => {setActiveValues((av)=> ({...av, wh: pl}))}}
                key={pl}
                variant={ activeValues.wh === pl ? "contained": "text"}
                disabled={ (activeValues.rt !== null) && (prices.indexOf(activeValues.rt + pl) === -1) }
                >
                {pl}
              </Button>
            ))}
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={cleanUp} color="primary">
          Cancel
        </Button>
        <Button target="_blank" component="a"href={`${linkBase}?rt=${activeValues.rt || ""}&wh=${activeValues.wh || ""}`}>
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  )
}